<template>
  <div>
    <div v-if="loading">
      <b-spinner variant="primary"></b-spinner>
    </div>
    <div v-if="files.length > 0">
      <ul class="list-unstyled">
        <li v-for="f in files" :key="f.id">
          <b-button variant="link" @click="download(f)" class="text-left">{{f.name}}<b-icon icon="download" class="ml-3"></b-icon></b-button>
        </li>
      </ul>
    </div>
  </div>
</template>

<script>
import Api from '@/api/Api'

export default {
  props: [ 'id' ],
  data () {
    return {
      loading: true,
      files: []
    }
  },
  created () {
    this.loadData()
  },
  methods: {
    loadData () {
      var vm = this
      vm.loading = true
      Api().get(`Course/${vm.id}/Resources`)
        .then((r) => {
          vm.files = r.data
        })
        .catch((e) => {
          console.log(e)
        })
        .finally(() => {
          vm.loading = false
          vm.$emit('dataLoaded', vm.files)
        })
    },
    download (file) {
      var vm = this
      Api().get(`Course/${vm.id}/Resources/${file.id}/Download`, { responseType: 'blob' })
        .then((r) => {
          const filename = r.headers['content-disposition'].split('filename=')[1].replace(/['"]+/g, '')
          const blob = new Blob([ r.data ])
          const link = document.createElement('a')
          link.href = window.URL.createObjectURL(blob)
          link.download = filename
          link.click()
        })
        .catch((e) => {
          console.log(e)
        })
    }
  }
}
</script>

<style>

</style>
